module.exports = __webpack_public_path__ + "img/Logo b&w negative.331d617a.png";